<div class="message-container">
  @if (data.showSpinner) {
    <mat-spinner color="primary" [diameter]="20" mode="indeterminate"></mat-spinner>
  }
  <div class="message">{{data.message}}</div>
  @if (data.showCloseButton) {
    <div>
      @if (!data.closeButtonText) {
        <button
          mat-icon-button
          (click)="closeSnackBar()">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      }
      @if (!!data.closeButtonText) {
        <button
          mat-flat-button
          color="primary"
          (click)="closeSnackBar()">
          {{data.closeButtonText}}
        </button>
      }
    </div>
  }
</div>
@if (progress$) {
  <div class="duration-indicator">
    <mat-progress-bar mode="determinate" [value]="progress$ | async" color="primary"></mat-progress-bar>
  </div>
}
